import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_2 = { class: "px-4 lg:px-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-16" }, null, -1)
const _hoisted_4 = { class: "px-4 lg:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_PoolsTable = _resolveComponent("PoolsTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isWalletReady)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BalStack, {
              horizontal: "",
              justify: "between",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('myInvestments')), 1),
                _createVNode(_component_BalBtn, {
                  onClick: _ctx.navigateToCreatePool,
                  color: "red",
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('createAPool.title')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_PoolsTable, {
            isLoading: _ctx.isLoadingUserPools,
            data: _ctx.userPools,
            noPoolsLabel: _ctx.$t('noInvestments'),
            showPoolShares: "",
            selectedTokens: _ctx.selectedTokens,
            class: "mb-8"
          }, null, 8, ["isLoading", "data", "noPoolsLabel", "selectedTokens"]),
          _hoisted_3
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BalStack, {
        horizontal: "",
        justify: "between",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('investmentPools')), 1),
          _createVNode(_component_BalBtn, {
            onClick: _ctx.navigateToCreatePool,
            color: "red",
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('createAPool.title')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_PoolsTable, {
      isLoading: _ctx.isLoadingPools,
      data: _ctx.filteredPools,
      noPoolsLabel: _ctx.$t('noPoolsFound'),
      isPaginated: _ctx.poolsHasNextPage,
      isLoadingMore: _ctx.poolsIsFetchingNextPage,
      onLoadMore: _ctx.loadMorePools,
      selectedTokens: _ctx.selectedTokens,
      class: "mb-8"
    }, null, 8, ["isLoading", "data", "noPoolsLabel", "isPaginated", "isLoadingMore", "onLoadMore", "selectedTokens"])
  ]))
}